"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMenuMobile = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_dom_1 = __importDefault(require("react-dom"));
var react_redux_1 = require("react-redux");
var react_redux_2 = require("react-redux");
var useModal_1 = require("./useModal");
var useMenuMobile = function (id) {
    var modalParentElement = (0, react_1.useRef)((0, useModal_1.createModalParent)('menu-mobile-wrapper'));
    var dispatch = (0, react_redux_1.useDispatch)();
    // @ts-ignore
    var _a = (0, react_redux_2.useSelector)(function (_a) {
        var modals = _a.modals;
        return modals[id] ? modals[id] : {};
    }, react_redux_2.shallowEqual), isActive = _a.isActive, payload = _a.payload;
    var triggerModal = (0, react_1.useCallback)(function (isActive, payload) {
        if (payload === void 0) { payload = null; }
        return function () {
            (0, useModal_1.toggleBlockBodySimple)(isActive);
            (0, useModal_1.handleTriggerModal)(dispatch, { id: id, isActive: isActive, payload: payload })();
        };
    }, []);
    var render = (0, react_1.useCallback)(function (Component) { return (modalParentElement.current ? react_dom_1.default.createPortal(Component, modalParentElement.current) : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {})); }, [modalParentElement.current, isActive]);
    (0, react_1.useEffect)(function () {
        triggerModal(false)();
    }, []);
    return { render: render, openMenu: triggerModal(true), closeMenu: triggerModal(false), isActive: isActive, payload: payload, toggleMenu: triggerModal };
};
exports.useMenuMobile = useMenuMobile;
